import { useMutation } from '@tanstack/react-query';

import httpService from '@/lib/http.service';
import { MutationConfig } from '@/lib/react-query';

export interface CreatePaymentPayload {
  contractId: number;
}

export const createPayment = ({ contractId }: CreatePaymentPayload): Promise<{ data: { paymentLink: string } }> => {
  return httpService.post(`/contracts/${contractId}/pay`, null);
};

type UseCreatePaymentOptions = {
  mutationConfig?: MutationConfig<typeof createPayment>;
};

export const useCreatePayment = ({ mutationConfig }: UseCreatePaymentOptions = {}) => {
  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    onSuccess: (data, ...args) => {
      onSuccess?.(data, ...args);
    },
    ...restConfig,
    mutationFn: createPayment,
  });
};
